import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'success' | 'warning' | 'info' | 'popular' | 'destructive';
  size?: 'sm' | 'md';
  style?: React.CSSProperties;
}

const StyledBadge = styled.span<BadgeProps>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.semibold};
  border-radius: ${theme.borderRadius.full};
  white-space: nowrap;

  ${props => props.size === 'sm' ? `
    padding: 0.25rem 0.75rem;
    font-size: ${theme.typography.fontSize.xs};
  ` : `
    padding: 0.375rem 1rem;
    font-size: ${theme.typography.fontSize.sm};
  `}

  ${props => {
    switch (props.variant) {
      case 'success':
        return `
          background: ${theme.colors.mint[100]};
          color: ${theme.colors.mint[700]};
        `;
      case 'warning':
        return `
          background: ${theme.colors.accent.peach};
          color: #92400e;
        `;
      case 'info':
        return `
          background: ${theme.colors.accent.sky};
          color: #1e40af;
        `;
      case 'popular':
        return `
          background: linear-gradient(135deg, #FFD6A5 0%, #FFAB91 100%);
          color: #7c2d12;
          box-shadow: ${theme.shadows.sm};
        `;
      case 'destructive':
        return `
          background: ${theme.colors.status.error}20;
          color: ${theme.colors.status.error};
        `;
      default:
        return `
          background: ${theme.colors.glow.mint};
          color: ${theme.colors.primary[700]};
        `;
    }
  }}
`;

export const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md' 
}) => {
  return (
    <StyledBadge variant={variant} size={size}>
      {children}
    </StyledBadge>
  );
};

